import plural from 'pluralize';
import { config } from '@/config';
import { explorerAnalytics } from '@/lib/analytics';
import { kebabCase } from 'change-case-all';
import { Endpoint } from 'src/context/openapi/types';

interface ApiDocumentationLinkProps {
  resource: string;
  apiEndpoint: Endpoint;
}

export const ApiDocumentationLink: React.FC<ApiDocumentationLinkProps> = ({
  resource,
  apiEndpoint,
}) => {
  const getPluralizedResource = (resource: string): string => {
    try {
      const pluralized = plural(resource);
      return pluralized !== resource ? pluralized : resource;
    } catch (_error) {
      return resource;
    }
  };

  const apiDocsUrl = `${config.apiDocsBaseUrl}/${getPluralizedResource(resource)}/${kebabCase(apiEndpoint.name)}`;

  return (
    <a
      href={apiDocsUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={
        'text-blue-600 hover:text-blue-800 underline italic text-[12px] font-medium inline-flex items-center gap-1 transition-colors duration-200'
      }
      onClick={() => {
        explorerAnalytics.docsLinkClicked({
          resource: resource || '',
          endpoint: apiEndpoint.name || '',
          linkType: 'api_documentation',
        });
      }}
    >
      <span>API Reference →</span>
    </a>
  );
};
